<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BHtZ4f/OEBPS/images/9781443165006_Outside_Front_Cover.jpg?1684988669053" alt="This image is the cover for the book Spirit Animals #7: The Evertree, Animal totem"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spirit Animals #7: The Evertree, Animal totem
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>See below for English description.</strong></p><p>Ensemble, Conor, Abéké, Meilin et Rollon ont traversé Erdas, et ont poursuivi leur impitoyable ennemi. Ils ont ri et se sont battus ensemble. Ils ont relevé des défis et ont perdu des amis. Certains se sont même perdus eux-mêmes.</p><p>Maintenant, ce périple tire à sa fin. Ils doivent se rendre dans un endroit oublié par le temps et faire face à un ancien ennemi qui s'échappe de prison. Ils n'ont qu'une chance pour l'arrêter... sinon le monde entier tremblera.</p><p> </p><p>Together, Conor, Abéké, Meilin, and Rollan have journeyed across Erdas, racing to stop a merciless foe. They have laughed and fought together. They've won challenges and lost friends. Some have even lost themselves.</p><p>Now that journey is about to end. They must reach a place forgotten by time and face off against an ancient enemy breaking free from his prison. They have just one chance to stop him . . . or the whole world will shatter.</p><p>Original title: <em>Spirit Animals #7: The Evertree</em></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Lu
      </h2>
      
      <p class="authorDescription body article"><p><strong>Marie Lu</strong> est l&#39;auteure class&#233;e au palmar&#232;s du <em>New York Times</em> de la trilogie <em>Legend</em>. Avant de poursuivre une carri&#232;re en &#233;criture, elle a travaill&#233; en tant qu&#39;artiste en animation Flash dans l&#39;industrie des jeux vid&#233;o. Elle vit &#224; Los Angeles.</p><p>&#160;</p><p><strong>Marie Lu</strong> is the <em>New York Times</em> bestselling author of the <em>Legend</em> Trilogy. Before becoming a full-time writer, she worked in the video game industry as a Flash artist. She currently lives in Los Angeles.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Éditions Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25eb5c5b